module.exports = __webpack_public_path__ + "img/bucket_tote_thumb.14a2b1e8.jpg";